import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
  ViewChildren,
  ElementRef,
  QueryList,
  ChangeDetectorRef,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatSelect } from '@angular/material/select';
import { MatSort, SortDirection } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { PermissionService } from 'src/app/utils/permission.service';
import { UtilityService } from 'src/app/utils/utility.service';
import {
  InitDisplayedCol,
  Page,
  DisplayColTypes,
  PageCtrl,
} from '../../models/common';
import { NotificationService } from 'src/app/utils/notification.service';
import { ColumnType } from '../../models/table';

@Component({
  selector: 'app-table3-ui',
  templateUrl: './table3-ui.component.html',
  styleUrls: ['./table3-ui.component.css'],
})
export class Table3UiComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('table') table: MatTable<any>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChildren('fundSourceSelect', { read: MatSelect })
  fundSourceSelect: QueryList<MatSelect>;
  @ViewChildren('glAccountSelect', { read: MatSelect })
  glAccountSelect: QueryList<MatSelect>;

  @Input() set data(payload: any) {
    let data = payload;
    if (payload) {
      data = this.preCheckSelectedIds(payload);
    }
    this.dataSource = new MatTableDataSource(
      Array.isArray(payload) ? payload : null,
    );
    // A new page of rows has no row the user just changed.
    this.applySource?.clear();
  }
  @Input() initColumns: any[];
  @Input() location: string;
  @Input() selectedIds: Set<any> = new Set();

  @Input() pageProp: Page;
  @Input() showPagination: boolean;
  @Input() showFooter: boolean = false;

  @Input() usePermission: boolean = false;

  @Input() matSortActive: string = '';
  @Input() matSortDirection: SortDirection = '';
  @Input() showCheckboxes: boolean = true;
  @Input() draggable: boolean = false;
  @Input() dragDisabled: boolean = false;

  @Input() loanProducts: any[] = [];

  @Output() checkboxCheckEmit: EventEmitter<any> = new EventEmitter();
  @Output() changefunSourceGls: EventEmitter<any> = new EventEmitter();
  @Output() pageSizeToggle: EventEmitter<number> = new EventEmitter();
  @Output() PageCtrlToggle: EventEmitter<PageCtrl> = new EventEmitter();
  @Output() sortEmit: EventEmitter<any> = new EventEmitter();
  @Output() rowClick: EventEmitter<any> = new EventEmitter();
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onApplyToAll: EventEmitter<any> = new EventEmitter();
  @Output() customInputChange: EventEmitter<any> = new EventEmitter();

  public leaderAccountIds: Set<number> = new Set(); // Track all leader IDs
  public itemLeaderMap: Map<number, number> = new Map(); // Map item ID to its leader ID
  public leaderColors: Map<number, string> = new Map();
  public leaderSelectedAccounts: Map<number, number> = new Map();
  public appliedLeaderColors: Map<number, string> = new Map();
  @Output() glAccountChange: EventEmitter<any> = new EventEmitter();
  @Output() glAccountApplyToAll: EventEmitter<any> = new EventEmitter();
  @Output() fundSourceChange: EventEmitter<any> = new EventEmitter();
  @Output() fundSourceApplyToAll: EventEmitter<any> = new EventEmitter();
  @Output() editAction: EventEmitter<any> = new EventEmitter();
  @Output() deleteAction: EventEmitter<any> = new EventEmitter();
  @Output() rowDrop: EventEmitter<CdkDragDrop<any[]>> = new EventEmitter();

  private colorIndex: number = 0;
  @Input() primaryMessage: boolean;

  public displayedColumns: string[];
  public dataSource: MatTableDataSource<any>;
  public masterCheckboxChecked: boolean;
  // public checkedIds: any[] = [];
  public leaderFundSourceAccountId: number;

  public selectiedItems: number = 0;
  minDate: Date;
  maxDate: Date;

  leaderAccountId: number;
  leaderLoanOfficerAccountId: number;
  selectInput: FormControl = new FormControl('');
  public symbol: string = '₦';

  constructor(
    private permissionsService: PermissionService,
    private notif: NotificationService,
    public utils: UtilityService,
    public cdr: ChangeDetectorRef,
  ) {
    const currentYear = new Date().getFullYear();
    const currentTime = new Date();
    this.minDate = new Date(currentYear - 6, 0, 1);
  }

  ngOnInit(): void {
    this.displayedColumns = this.initColumns.map((col) => col.key);
    this.glAccountSetDefault();
  }

  // renderTableMessageWhenEmpty(message: string) {
  //   if (message === 'clients') {
  //     this.primaryMessage = true;
  //   }
  // }

  ngOnChanges(changes: SimpleChanges) {
    this.displayedColumns = this.initColumns.map((col) => col.key);
    this.glAccountSetDefault();
    this.selectedIds = new Set();

    if (!this.selectedIds.size) {
      this.masterCheckboxChecked = false;
    }
    if (
      changes['data'] &&
      changes['data'].currentValue !== changes['data'].previousValue
    ) {
      this.selectedIds = new Set();

      /* Clear the rows' own flags with it. preCheckSelectedIds runs from the
         `data` setter — i.e. before this hook — so a new page whose keys match
         the previous selection would come back rendered as checked while the
         selection set here is emptied. The header checkbox is derived from those
         flags, so leaving them set would tick the master with nothing selected. */
      (this.dataSource?.data ?? []).forEach((row: any) => (row.checked = false));
      this.masterCheckboxChecked = false;
    }

    if (!this.selectedIds.size) {
      this.masterCheckboxChecked = false;
    }
  }
  public get selectedItemsCount(): number {
    if (!this.dataSource?.data) {
      return 0;
    }
    return this.dataSource.data.filter((item) => item.checked).length;
  }

  loanOfficerApplyToSelected(
    item: any,
    column: InitDisplayedCol,
    index: number,
  ) {
    if (!item[column.value]) {
      this.notif.error(
        $localize`:@@no_loan_officer_selected:No loan officer selected`,
      );
      return;
    }
    const selectedItems = this.dataSource.data.filter((loan) => loan.checked);

    if (selectedItems.length === 0) {
      this.notif.error(
        $localize`:@@no_items_selected:Please select items first`,
      );
      return;
    }

    this.leaderLoanOfficerAccountId = item.id;
    const selectedLoanOfficerId = item[column.value];

    this.selectiedItems = 0;
    let skippedCount = 0;

    this.dataSource.data = this.dataSource.data.map((loan) => {
      if (!loan.checked) {
        return loan;
      }

      if (!loan.hasLoanOfficer) {
        loan[column.value] = selectedLoanOfficerId;
        this.selectiedItems++;
      } else {
        skippedCount++;
      }

      return loan;
    });

    if (this.selectiedItems > 0) {
      // this.notif.success(
      //   $localize`:@@loan_officer_applied:Loan officer applied to ${appliedCount} selected item(s)`
      // );
    }

    if (skippedCount > 0) {
      this.notif.info(
        $localize`:@@items_skipped:${skippedCount} selected item(s) already have a loan officer`,
      );
    }

    // Force table to re-render
    this.table.renderRows();
  }

  ngAfterViewInit() {
    if (this.dataSource) this.dataSource.sort = this.sort;
  }

  /**
   * Stable identity for a row. These tables are keyed by `id` on some screens
   * (repayment approval, group postings) and by `accountId` on others (bulk
   * approval / authorization / disbursement), so both are honoured. The row
   * itself is the last resort, which makes the comparison reference-based
   * rather than silently matching every unkeyed row to every other one.
   */
  private rowKey(row: any): any {
    return row?.id ?? row?.accountId ?? row;
  }

  private preCheckSelectedIds(data: any[]) {
    if (!data || !data.length) return data;

    /* selectedIds holds row OBJECTS (that is what gets emitted to the parent,
       which reads rowData.accountId / rowData.id off them), so `has(d.id)` was
       comparing an id against a set of objects and was therefore always false.
       Comparing keys keeps the checkboxes in step with the selection when the
       data is re-bound. */
    const selectedKeys = new Set(
      Array.from(this.selectedIds).map((row) => this.rowKey(row)),
    );

    return data.map((d) => {
      d.checked = selectedKeys.has(this.rowKey(d));
      return d;
    });
  }

  /**
   * The header checkbox is checked only when every row on the page is checked.
   *
   * It used to be `selectedIds.size === dataSource.data.length`, which ticked
   * the master as soon as the size happened to match the row count — including
   * the case where the set still held rows that are no longer on the page, so
   * one click could tick the master and make the parent total every row.
   */
  private syncMasterCheckbox(): void {
    const rows: any[] = this.dataSource?.data ?? [];
    this.masterCheckboxChecked =
      rows.length > 0 && rows.every((row: any) => !!row.checked);
  }
  // Add this to your component class

  // getavalue(value: any) {
  //   console.log(value);
  // }
  public hasPermission(perms: string[]) {
    return this.permissionsService.hasPermissionList(perms);
  }

  public showToolTip(val, maxLen) {
    const len = maxLen ?? 50;
    if (val.length <= len) {
      return val;
    }
    return '';
  }

  public announceSortChange(sortState: any) {
    this.sortEmit.emit(sortState);
  }

  public onPageSizeToggle(val: number) {
    this.pageSizeToggle.emit(val);
  }
  public onPageCtrlToggle(val: PageCtrl) {
    this.PageCtrlToggle.emit(val);
  }

  public onCheck(event: MatCheckboxChange, item: any) {
    /* Only the clicked row changes. The previous version looped every row and
       matched on `d.id === item.id` after assigning `item.id = item.id ||
       item.accountId` — which mutated the API row, and matched undefined
       against undefined on tables whose rows carry neither key, checking every
       row at once. */
    const key = this.rowKey(item);
    const row =
      this.dataSource.data.find((d: any) => this.rowKey(d) === key) ?? item;

    row.checked = event.checked;

    if (event.checked) {
      this.selectedIds.add(row);
    } else {
      this.selectedIds.delete(row);
    }

    this.syncMasterCheckbox();
    this.checkboxCheckEmit.emit(this.selectedIds);
  }

  public onCheckAll(event: MatCheckboxChange) {
    this.masterCheckboxChecked = event.checked;
    this.dataSource.data.forEach((element: any) => {
      element.checked = event.checked;
    });

    /* Rebuilt rather than mutated so the emitted set never carries rows from a
       previous page. */
    this.selectedIds = event.checked
      ? new Set(this.dataSource.data)
      : new Set();

    this.checkboxCheckEmit.emit(this.selectedIds);
  }

  public unCheckAll() {
    this.masterCheckboxChecked = false;
    this.data.forEach((element: any) => {
      element.checked = false;
    });
  }

  public triggerRowClick(rowId: number) {
    this.rowClick.emit(rowId);
  }

  public onEditAction(item: any) {
    this.editAction.emit(item);
  }

  public onDeleteAction(item: any) {
    this.deleteAction.emit(item);
  }

  public onRowDrop(event: CdkDragDrop<any[]>): void {
    if (this.draggable && !this.dragDisabled) this.rowDrop.emit(event);
  }

  public getStatusText(value) {
    switch (value) {
      case 'manual':
        'grey-500';
    }
  }
  // findFundSourceByProductId(productId: number) {
  //   return this.loanProducts.find(loanProduct => loanProduct.value === 300).fundSources
  // }

  loanOfficerApplyToAll(item: any, column: InitDisplayedCol, index: number) {
    if (!item[column.value]) {
      this.notif.error(
        $localize`:@@no_loan_officer_selected:No loan officer selected`,
      );
      return;
    }
    this.leaderLoanOfficerAccountId = item.id;
    const selectedLoanOfficerId = item[column.value];
    this.dataSource.data = this.dataSource.data.map((loan) => {
      if (loan['hasLoanOfficer']) return loan;
      loan[column.value] = selectedLoanOfficerId;
      return loan;
    });
  }
  public previewFundSourceMatch(item: any, column: InitDisplayedCol): void {
    const selectedFundSourceId = item.fundSourceGlId; // Use explicit property name

    if (!selectedFundSourceId) {
      return;
    }

    this.leaderFundSourceAccountId = item.accountId;

    // Emit event to parent (parent will handle all the logic)
    this.fundSourceChange.emit({ item, column, selectedFundSourceId });
  }

  // 4. Add this method to apply fund source to all matching
  public fundSourceApplytoAll(
    item: any,
    column: InitDisplayedCol,
    index: number,
  ): void {
    if (!item.fundSourceGlId) {
      this.notif.error(
        $localize`:@@no_fund_source_selected:No fund source selected`,
      );
      return;
    }

    // Emit to parent to handle the logic
    this.fundSourceApplyToAll.emit({
      item,
      column,
      selectedFundSourceId: item.fundSourceGlId,
    });
  }

  // 5. Add this method for fund source tooltip
  public getFundSourceApplyButtonTooltip(item: any): string {
    if (!item.fundSourceGlId) {
      return 'Select a fund source to see available matches';
    }

    if (item._fundSourceMatchCount === 0) {
      return 'No other loan accounts have access to this fund source';
    }

    return `Automatically apply this fund source to ${item._fundSourceMatchCount} matching loan account(s) that have access to it`;
  }

  // 6. Add these helper methods for visual states
  public hasMatchingFundSource(item: any): boolean {
    return item._hasFundSourceMatch === true;
  }

  public isFundSourceSourceItem(item: any): boolean {
    return item._isFundSourceSource === true;
  }

  /* A 'customOptionSelectPicker' column carries its own options and hooks, so
     the page decides what the choices are and what "apply to all" reaches.
     An options function must hand back the same array on every call, or the
     select would rebuild its options on each change-detection pass. */
  public optionsFor(column: InitDisplayedCol, item: any): any[] {
    return typeof column.options === 'function'
      ? column.options(item) ?? []
      : column.options ?? [];
  }

  public onOptionSelect(column: InitDisplayedCol, item: any): void {
    this.takeApplySource(column, item);
    if (typeof column.onOptionChange === 'function') {
      column.onOptionChange(item);
    }
  }

  /* The apply buttons belong to the row the user last changed in that column.
     Without this every row that merely differed from it showed its own
     "Apply to all (1)", since each one differs from the changed row. */
  private applySource = new Map<string, any>();

  public isApplySource(column: InitDisplayedCol, item: any): boolean {
    return this.applySource.get(column.key) === item;
  }

  /* Setting another row by hand to the same value as the row holding the
     buttons leaves the buttons where they are, so their count just drops; a
     different value moves them to the row just changed. */
  private takeApplySource(column: InitDisplayedCol, item: any): void {
    const source = this.applySource.get(column.key);
    if (!source || source === item || source[column.value] !== item[column.value]) {
      this.applySource.set(column.key, item);
    }
  }

  public onConfirmChange(
    column: InitDisplayedCol,
    item: any,
    checked: boolean,
  ): void {
    item[column.value] = checked;
    if (checked) {
      this.takeApplySource(column, item);
    } else if (this.isApplySource(column, item)) {
      this.applySource.delete(column.key);
    }
  }

  public optionWillUpdate(column: InitDisplayedCol, item: any): boolean {
    return typeof column.isMatch === 'function' && !!column.isMatch(item);
  }

  public showOptionApply(column: InitDisplayedCol, item: any): boolean {
    return (
      typeof column.showApplyButton === 'function' &&
      !!column.showApplyButton(item)
    );
  }

  public optionApplyText(column: InitDisplayedCol, item: any): string {
    return typeof column.getApplyButtonText === 'function'
      ? column.getApplyButtonText(item)
      : '';
  }

  public optionApplyTooltip(column: InitDisplayedCol, item: any): string {
    return typeof column.getApplyButtonTooltip === 'function'
      ? column.getApplyButtonTooltip(item)
      : '';
  }

  public applyOption(column: InitDisplayedCol, item: any): void {
    if (typeof column.onApplyClick === 'function') {
      column.onApplyClick(item);
    }
  }

  /* A 'customConfirmCheckbox' column: a per-row tick the page asks for on some
     rows only. Rows it doesn't apply to show the label (or "-") instead. */
  public confirmApplies(column: InitDisplayedCol, item: any): boolean {
    return typeof column.isApplicable === 'function'
      ? !!column.isApplicable(item)
      : true;
  }

  public confirmLabel(column: InitDisplayedCol, item: any): string {
    return typeof column.getLabel === 'function'
      ? column.getLabel(item) ?? ''
      : '';
  }

  public confirmTooltip(column: InitDisplayedCol, item: any): string {
    return typeof column.getTooltip === 'function'
      ? column.getTooltip(item) ?? ''
      : '';
  }

  public confirmInfoOpen(column: InitDisplayedCol, item: any): void {
    if (typeof column.onTooltipOpen === 'function') {
      column.onTooltipOpen(item);
    }
  }

  public confirmInvalid(column: InitDisplayedCol, item: any): boolean {
    return typeof column.isInvalid === 'function' && !!column.isInvalid(item);
  }

  /* The unticked rows a ticked row's "Apply to all" (every row on the page) or
     "Apply to Selected" (the selected ones) would tick. The row itself needn't
     be selected; it only has to be ticked, since a tick is what gets copied. */
  private confirmTargets(
    scope: 'all' | 'selected',
    column: InitDisplayedCol,
    item: any,
  ): any[] {
    if (!item[column.value]) return [];
    return (this.dataSource?.data ?? []).filter(
      (row) =>
        row !== item &&
        (scope === 'all' || row.checked) &&
        !row[column.value] &&
        this.confirmApplies(column, row),
    );
  }

  public confirmApplyCount(
    scope: 'all' | 'selected',
    column: InitDisplayedCol,
    item: any,
  ): number {
    return this.confirmTargets(scope, column, item).length;
  }

  public applyConfirmTo(
    scope: 'all' | 'selected',
    column: InitDisplayedCol,
    item: any,
  ): void {
    const rows = this.confirmTargets(scope, column, item);
    rows.forEach((row) => (row[column.value] = true));
    if (!rows.length) return;
    this.notif.success(
      scope === 'all'
        ? $localize`:@@confirm_applied_to_all:${column.name}:column: ticked on ${rows.length}:count: more item(s)`
        : $localize`:@@confirm_applied_to_selected:${column.name}:column: ticked on ${rows.length}:count: more selected item(s)`,
    );
  }

  /* "Apply to all" / "Apply to Selected" for a column with
     applyToAllOrSelected: the rows a row's pick would change, on the whole
     page or among the selected ones. Rows already on that value, and rows
     whose own options don't include it, are left out. Each button shows its
     count and hides at zero, the same as the down payment buttons. */
  private optionTargets(
    scope: 'all' | 'selected',
    column: InitDisplayedCol,
    item: any,
  ): any[] {
    const value = item[column.value];
    if (!value) return [];
    return (this.dataSource?.data ?? []).filter(
      (row) =>
        row !== item &&
        (scope === 'all' || row.checked) &&
        row[column.value] !== value &&
        this.optionsFor(column, row).some((o) => o.value === value),
    );
  }

  public optionApplyCount(
    scope: 'all' | 'selected',
    column: InitDisplayedCol,
    item: any,
  ): number {
    return this.optionTargets(scope, column, item).length;
  }

  public applyOptionTo(
    scope: 'all' | 'selected',
    column: InitDisplayedCol,
    item: any,
  ): void {
    const value = item[column.value];
    const rows = this.optionTargets(scope, column, item);
    rows.forEach((row) => (row[column.value] = value));

    if (rows.length) {
      this.notif.success(
        $localize`:@@option_applied_to_items:${column.name}:column: applied to ${rows.length}:count: item(s)`,
      );
    }
  }
  public previewGlAccountMatch(item: any, column: InitDisplayedCol): void {
    const selectedAccountId = item[column.value];

    if (!selectedAccountId) {
      return;
    }

    this.leaderAccountId = item.id;

    // Emit event to parent (parent will handle all the logic)
    this.glAccountChange.emit({ item, column, selectedAccountId });
  }

  glAccountApplytoAll(item: any, column: InitDisplayedCol, index: number) {
    if (!item[column.value]) {
      this.notif.error($localize`:@@no_account_selected:No account selected`);
      return;
    }

    // Emit to parent to handle the logic
    this.glAccountApplyToAll.emit({
      item,
      column,
      selectedGlId: item[column.value],
    });
  }

  public getApplyButtonTooltip(item: any): string {
    if (!item.glId) {
      return 'Select a GL account to see available matches';
    }

    if (item._matchCount === 0) {
      return 'No other empty loan accounts in the same branch have access to this GL account';
    }

    return `Automatically apply this account to ${item._matchCount} loan account(s) in the same branch `;
  }

  public hasMatchingGlAccount(item: any): boolean {
    return item._hasMatch === true;
  }
  public isSourceItem(item: any): boolean {
    return item._isSource === true;
  }

  disableGlAndFundsourceFIeld() {
    const glColumn = this.initColumns.find((val) => val.disable);
    if (glColumn) {
      return glColumn;
    }
  }

  glAccountSetDefault() {
    const glColumn = this.initColumns.find(
      (val) => val.type === 'customGlAccountSelectPicker',
    );
    if (!glColumn) return;
    this.dataSource.data = this.dataSource?.data?.map((loan) => {
      const branchGls = loan?.branch?.branchGls || loan?.branchGls || [];
      const hasBranchGls = loan?.repaymentGlId;

      if (hasBranchGls) {
        loan[glColumn.value] = hasBranchGls;
        return loan;
      }

      if (branchGls.length === 1) {
        loan[glColumn.value] = branchGls[0].id;
        return loan;
      }
      return loan;
    });
  }

  applyToAll(accountId: number, index: number) {
    this.leaderAccountId = accountId;
    const selectedFundSourceGlId = this.fundSourceSelect.get(index).value;

    this.dataSource.data.forEach((approvedLoan) => {
      // const fundSourceGlIds = this.findFundSourceByProductId(approvedLoan.productId).map((fundSource) => fundSource.glAccountId);
      approvedLoan.fundSourceGlId = selectedFundSourceGlId;
      // if (fundSourceGlIds.includes(selectedFundSourceGlId))
      this.fundSourceSelect.forEach(
        (selectInput) => (selectInput.value = selectedFundSourceGlId),
      );
    });
  }

  formatCurrency(amount) {
    // TODO: Use currency code to get the currency symbol
    // i.e en-NG/NGN = ₦, en-US/USD = $ etc
    return amount
      ? `${this.symbol}${amount
          .replace(/[^0-9\.]/g, '')
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
      : null;
  }

  applyToAllCustomInput(value: number, fieldName: string) {
    this.dataSource.data = this.dataSource.data.map((record) => {
      record[fieldName] = this.formatCurrency(value);
      return record;
    });
    this.customInputChange.emit({ item: null, column: { value: fieldName } });
  }

  public isNumericFooter(column: InitDisplayedCol): boolean {
    return ['currency', 'number', 'percentile', 'customInput'].includes(
      column.type,
    );
  }

  public shouldDisableCheckboxes(): boolean {
    try {
      // If permission checking is disabled, never disable checkboxes
      if (!this.usePermission) {
        return false; // false means don't disable
      }

      // Find the checkbox column configuration
      const checkboxColumn = this.initColumns?.find(
        (col) => col.type === 'checkbox',
      );

      // If no checkbox column exists or it has no permission requirements, don't disable
      if (
        !checkboxColumn ||
        !checkboxColumn.perms ||
        checkboxColumn.perms.length === 0
      ) {
        return false; // false means don't disable
      }

      // Check if user has the required permissions
      const hasPerms = this.hasPermission(checkboxColumn.perms);

      // Return true to DISABLE checkboxes if user DOESN'T have permissions
      // Return false to ENABLE checkboxes if user HAS permissions
      return !hasPerms; // Invert the logic since we want to disable when permissions are missing
    } catch (error) {
      console.error('Error in hasCheckboxPermissions:', error);
      return false; // Default to enabling checkboxes if there's an error
    }
  }
}
